<div
  *ngFor="let notification of userNotifications; let i = index"
  [padding-bottom]="10"
>
  <p-card
    [header]="getValue(notification, 'subject')"
    [subheader]="notification.Name"
    styleClass="p-card-shadow"
  >
    <ng-template pTemplate="header">
      <p-chip
        [label]="notification.NotificationStatusDescription"
        styleClass="mr-2"
      ></p-chip>
    </ng-template>
    <!--card content-->
    {{ getValue(notification, "body") }}
    <ng-template pTemplate="footer">
      <p-button
        *ngIf="setPublishNotificationVisible(notification.NotificationStatusId)"
        label="Publish"
        icon="pi pi-send"
        (onClick)="changeNotificationStatus(notification, NotificationStatuses.Publishing)"
      ></p-button>
      <p-button
        *ngIf="setExpireNotificationVisible(notification.NotificationStatusId)"
        label="Set as expired"
        icon="pi pi-calendar-times"
        styleClass="p-button-warning"
        (onClick)="changeNotificationStatus(notification, NotificationStatuses.Expired)"
      ></p-button>
      <p-button
        *ngIf="setDeleteNotificationVisible(notification.NotificationStatusId)"
        label="Delete"
        icon="pi pi-times-circle"
        styleClass="p-button-danger"
        [style]="{ 'margin-left': '.5em' }"
        (onClick)="changeNotificationStatus(notification, NotificationStatuses.Deleted)"
      ></p-button>
    </ng-template>
  </p-card>


</div>
